import { GroupBase, GroupProps, MenuListProps, components as SelectComponents } from 'react-select';

export const CustomGroupComponent = (props: GroupProps<unknown, boolean>) => {
  const { Heading, getStyles, children, label, headingProps, cx, theme } = props;

  return (
    <div className="flex-1">
      <Heading
        selectProps={{} as any}
        getClassNames={(cls) => cls}
        className="p text-secondary-500 bold"
        theme={theme}
        getStyles={getStyles}
        cx={cx}
        {...headingProps}>
        <span style={{ textTransform: 'none' }}>{label}</span>
      </Heading>
      <div className="pb-4">{children}</div>
    </div>
  );
};
export const CustomMenuList = (props: MenuListProps<unknown, boolean>) => {
  return (
    <SelectComponents.MenuList {...props}>
      <div className="py-2 layout-column">{props.children}</div>
    </SelectComponents.MenuList>
  );
};
